<template>
    <div class="input-wrapper" :class="InputMessage.parentClass">
        <!-- || this.InputMessage.type==='phone'  -->
        <input
            class="input-content"
            v-model.trim="message"
            :type="
                InputMessage.type === 'integer' || InputMessage.type === 'phone'
                    ? 'number'
                    : InputMessage.type
            "
            :style="InputMessage.inputStyle"
            :placeholder="InputMessage.placeholder"
            :disabled="InputMessage.disabled"
            :class="[
                { clearPadding: InputMessage.isSolt, disabled: InputMessage.disabled },
                InputMessage.parentClass
            ]"
            :maxlength="InputMessage.maxLength ? InputMessage.maxLength : undefined"
            @blur="outputVal"
            @change="changeValue"
            @focus="inputVal"
            @input="changeImmediately"
        />
    </div>
</template>
<script>
export default {
    name: 'Input',
    props: {
        InputMessage: {
            type: Object,
            default: {
                type: 'text',
                placeholder: '请输入',
                disabled: false
            }
        }
    },
    data() {
        return {
            message: '',
            originMessage: '',
            valueArr: [],
            clearBtnClick: false // 清除X是否已点击
        };
    },
    watch: {
        InputMessage: {
            deep: true,
            handler(value) {
                // 重新赋值
                this.init();
            }
        },
        message(n, o) {
            if (n) {
                if (this.InputMessage.type === 'phone' && n) {
                    if (n.length >= 12) {
                        this.message = o;
                        this.$emit('input-immediately', this.InputMessage.name, this.message);
                    }
                }
            }
        }
    },
    mounted() {
        this.init();
        // 键盘弹起收起事件
        this.listenKeybord();
    },
    methods: {
        changeValue() {
            // change事件分发内容
            this.$emit('input-val', this.InputMessage.name, this.message);
        },
        changeImmediately() {
            // input事件
            // 数据为空则不往下执行
            // if (!this.message) return; // zj 2019-8-12
            let maxLength = this.InputMessage.maxLen;
            // zj 2019-8-24
            if (this.InputMessage.type && this.InputMessage.type === 'integer') {
                this.message = this.message.replace(/\D/g, '');
            }
            if (this.message && this.message.length && this.message.length > maxLength) {
                this.message = this.message.substring(0, maxLength);
            }
            this.InputMessage.isSolt =
                this.message && this.message.length && this.message.length > 0 ? true : false;
            // 输入实时更新
            this.$emit('input-immediately', this.InputMessage.name, this.message);
        },
        outputVal() {
            // blur事件
            //   替换*
            this.$emit('blur-event', this.InputMessage.name, this.message);
        },
        inputVal() {
            // focus事件
            // 显示清除按钮
            this.$emit('focus-event', this.message);
        },
        clearValue() {
            this.$emit('input-val', this.InputMessage.name, this.message);
        },
        init() {
            // if (this.InputMessage.value) {
            this.message = this.InputMessage.value;
            // }
        },
        // 安卓软键盘弹起页面样式修改
        listenKeybord() {
            if (this.judgeDeviceType().isAndroid) {
                let originHeight =
                    document.documentElement.clientHeight || document.body.clientHeight;
                window.addEventListener(
                    'resize',
                    () => {
                        let resizeHeight =
                            document.documentElement.clientHeight || document.body.clientHeight;

                        if (originHeight < resizeHeight) {
                            this.$emit('keybord-hide');
                        } else {
                            this.$emit('keybord-show');
                        }
                        originHeight = resizeHeight;
                    },
                    false
                );
            }
        },
        judgeDeviceType() {
            let ua = window.navigator.userAgent.toLocaleLowerCase();
            let isIOS = /iphone|ipad|ipod/.test(ua);
            let isAndroid = /android/.test(ua);
            return {
                isIOS: isIOS,
                isAndroid: isAndroid
            };
        }
    }
};
</script>
<style lang="less">
@import '~@common/style/common.less';
.input-wrapper {
    display: inline-block;
    width: 100%;
    height: 100%;
    position: relative;
    /*background: red;*/
    .input-content {
        .centerY();
        border: 0;
        .f-16();
        color: #514f4f;
        display: inline-block;
        line-height: normal;
        text-align: left;
        letter-spacing: 1px;
        /*background: yellow;*/

        &::placeholder {
            color: #d5d7dd;
            .f-16();
            font-weight: normal;
        }
        &:disabled {
            color: #b7b7bf;
            opacity: 1;
            -webkit-text-fill-color: #b7b7bf;
            background: transparent;
        }
        &.clearPadding {
            width: 100%;
        }
    }
    input:focus {
        outline: none;
    }
}
</style>
